import type { TypographyOptions } from '@mui/material/styles/createTypography';

export const typography = {
  fontFamily:
    '"Lato", -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji"',
  body1: { fontSize: '0.9375rem', fontWeight: 400, lineHeight: 1.5 },
  body2: { fontSize: '0.8125rem', fontWeight: 400, lineHeight: 1.5 },
  button: { fontSize: '0.875rem', fontWeight: 600, letterSpacing: '0.01em', lineHeight: 1.2 },
  caption: { fontSize: '0.75rem', fontWeight: 400, lineHeight: 1.5 },
  subtitle1: { fontSize: '0.9375rem', fontWeight: 600, lineHeight: 1.45 },
  subtitle2: { fontSize: '0.8125rem', fontWeight: 600, lineHeight: 1.45 },
  overline: {
    fontSize: '0.75rem',
    fontWeight: 700,
    letterSpacing: '0.08em',
    lineHeight: 2,
    textTransform: 'uppercase',
  },
  h1: { fontSize: '3rem', fontWeight: 700, lineHeight: 1.05, letterSpacing: '-0.03em' },
  h2: { fontSize: '2.5rem', fontWeight: 700, lineHeight: 1.08, letterSpacing: '-0.025em' },
  h3: { fontSize: '2rem', fontWeight: 700, lineHeight: 1.12, letterSpacing: '-0.02em' },
  h4: { fontSize: '1.625rem', fontWeight: 700, lineHeight: 1.15, letterSpacing: '-0.015em' },
  h5: { fontSize: '1.25rem', fontWeight: 700, lineHeight: 1.2 },
  h6: { fontSize: '1rem', fontWeight: 700, lineHeight: 1.25 },
} satisfies TypographyOptions;
